export class PageMeta {
    public page: number = 1;
    public limit?: number;
    public has_next: boolean;
    public all?: boolean;
    public total?: number;
}
